import _ from 'lodash';
import { useState } from 'react';
import { setLayoutLocked } from '@/main/layout.actions';
import { useTranslation } from 'react-i18next';
import { ButtonWithDropdown, Icon } from '@seeqdev/qomponents';
import { sqWorkbenchLayoutStore, sqWorkbenchStore, sqWorkbookStore } from '@/core/core.stores';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';
import { useFlux } from '@/core/hooks/useFlux.hook';
import { doResetLayout } from '@/main/layout.utilities';
import { isWorksheet } from '@/main/routing.utilities';
import { isViewOnlyWorkbookMode } from '@/utilities/utilities';
import { WorksheetPreferencesModal } from '@/header/WorksheetPreferencesModal.molecule';

export const LayoutControls: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const [showWorksheetPreferencesModal, setShowWorksheetPreferencesModal] = useState(false);

  const layoutLocked = useFluxPath(sqWorkbenchLayoutStore, () => sqWorkbenchLayoutStore.layoutLocked);
  const { isTopic, acl } = useFlux(sqWorkbookStore);
  const { currentUser } = useFlux(sqWorkbenchStore);

  const isWorksheetOrViewOnly = isWorksheet() || isViewOnlyWorkbookMode();
  const isOwner = _.find(acl, (ace) => ace.identity.id === currentUser.id)?.isOwner;
  const canSavePreferences = isWorksheetOrViewOnly && isOwner && !isTopic;

  const actions = [
    {
      href: '#',
      icon: 'fa-window-restore',
      onClick: doResetLayout,
      label: t('LAYOUT.RESET_LAYOUT'),
      testId: 'resetLayout',
    },
    {
      href: '#',
      icon: layoutLocked ? 'fa-lock-open' : 'fa-lock',
      label: layoutLocked ? t('LAYOUT.UNLOCK_LAYOUT') : t('LAYOUT.LOCK_LAYOUT'),
      onClick: () => {
        setLayoutLocked(!layoutLocked);
      },
      hasDivider: canSavePreferences,
      testId: 'lockLayout',
    },
    ...(canSavePreferences
      ? [
          {
            href: '#',
            icon: 'fa-sliders',
            label: t('USER.WORKSHEET_PREFERENCES'),
            onClick: () => setShowWorksheetPreferencesModal(true),
            testId: 'worksheetPreferences',
          },
        ]
      : []),
  ];

  return (
    <>
      <div
        className="ml5 flexColumnContainer cursorPointer flexNoGrowNoShrink flexAlignCenter"
        data-testid="layoutMenu">
        <ButtonWithDropdown
          tooltip={t('LAYOUT.CONFIGURE')}
          tooltipPlacement="bottom"
          dropdownItems={actions}
          triggerIcon={
            <Icon
              icon="fa-table-layout"
              iconPrefix="fa-regular"
              type="white"
              extraClassNames="fa-xlg flexNoGrowNoShrink mr5 sq-navbar-default"
            />
          }
        />
      </div>
      {showWorksheetPreferencesModal && (
        <WorksheetPreferencesModal onClose={() => setShowWorksheetPreferencesModal(false)} />
      )}
    </>
  );
};
